import React, { useState, useEffect } from 'react';
import Login from './Login';
import DashboardContent from './DashboardContent';

const Dashboard = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated
    const auth = sessionStorage.getItem('dashboard_auth');
    const token = sessionStorage.getItem('dashboard_token');
    if (auth === 'true' && token) {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem('dashboard_auth');
    sessionStorage.removeItem('dashboard_user');
    sessionStorage.removeItem('dashboard_token');
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#F4F4F3] flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-4 border-[#AA94FF] border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return <DashboardContent onLogout={handleLogout} />;
};

export default Dashboard;
